import React, { useState } from 'react';
import { Checkbox } from '@cimpress/react-components';

const initialState = {
  example: false,
  disable: false,
  indeterminate: false,
};

const CheckboxDemo = () => {
  const [checkboxState, setCheckboxState] = useState(initialState);

  const onChange = (e, payload) => {
    const newState = { ...checkboxState, [payload]: !checkboxState[payload] };
    setCheckboxState(newState);
  };

  const { example, disable, indeterminate } = checkboxState;

  return (
    <div className="row">
      <div className="col-md-4">
        <form>
          <Checkbox
            label="Example"
            checked={example}
            payload="example"
            onChange={onChange}
            disabled={disable}
            indeterminate={indeterminate}
          />
          <Checkbox label="Disable the example" checked={disable} payload="disable" onChange={onChange} />
          <Checkbox
            label={<b>Make the example indeterminate</b>}
            checked={indeterminate}
            payload="indeterminate"
            onChange={onChange}
          />
        </form>
      </div>
    </div>
  );
};

export default CheckboxDemo;
